import { splitSort } from './useFilters';
import {
  sortFields,
  type AvailableBillable,
  type Filters,
  type Option,
} from './types';

import type { StringifiableRecord } from 'query-string';

const isOptionOrAvailableBillable = (
  value: unknown,
): value is Option | AvailableBillable => {
  return typeof value === 'object' && value !== null && 'value' in value;
};

const toStringify = ['contactAvailability'];

export const generateQueryFromFilters = (filters: Filters) => {
  const query: StringifiableRecord = {};

  Object.keys(filters).forEach((key) => {
    const value = filters[key as keyof Filters];
    if (key === 'sortString' && typeof value === 'string') {
      const [field, order] = splitSort(value);
      if (field === sortFields.at(-1)) {
        query[key] = `${sortFields.at(-2)}:${order.toUpperCase()}`;
      } else {
        query[key] = `${field}:${order.toUpperCase()}`;
      }
    } else if (toStringify.includes(key)) {
      query[key] = JSON.stringify(value);
    } else if (Array.isArray(value)) {
      query[key] = value.map((item) => item?.value || item);
    } else if (isOptionOrAvailableBillable(value)) {
      query[key] = value.value;
    } else if (value !== null && value !== undefined) {
      query[key] = value;
    }
  });

  return query;
};
